export default __webpack_public_path__ + "997f908c7f53417d80fde92234ae732c.svg";